<template>
  <panel>
    <div class="flex flex-wrap justify-center -mx-3 mt-3 pt-3">
      <div class="w-full md:w-2/5 px-3 h-full">
        <div class="text-center flex flex-col">
          <a href="#">
              <img src="img/guild-enhanced-plan.jpg" alt="" class="h-full">
          </a>
        </div>
      </div>
      <div class="w-full md:w-3/5 px-3">
        <div class="bg-white h-full transition flex flex-col">
          <div class="flex-grow p-3">
            <h3 class="uppercase">
              Four Key Features
            </h3>
            <p class="text-xs leading-tight mb-4 mt-2">
            </p>
            <div class="border-l-2" :class="{'border-guild-plan-orange': keyFeatureEnhanced === 1}">
              <h5 class="mb-1 ml-2">
                <span>Automated Prospecting Service (local on-market data and printed marketing)</span>
                <button @click="keyFeatureEnhanced = 1" v-show="keyFeatureEnhanced !== 1" class="font-normal ml-2"><i class="fa fa-angle-down"></i>
                </button>
              </h5>
               <p class="text-xs leading-tight mb-3 ml-2" v-show="keyFeatureEnhanced === 1">
                Provides access to on-market data for Sales and Lettings for your chosen trigger points and updated as frequently as every 4 hours, enabling targeted print to be sent to homeowners on a daily basis, ensuring that your brand is delivered to the doorstep as quickly as possible.
              </p>
            </div>
            <div class="border-l-2" :class="{'border-guild-plan-orange': keyFeatureEnhanced === 2}">
              <h5 class="mb-1 ml-2">
                Local SEO
                <button @click="keyFeatureEnhanced = 2" v-show="keyFeatureEnhanced !== 2" class="font-normal ml-2"><i class="fa fa-angle-down"></i>
                </button>
              </h5>
               <p class="text-xs leading-tight mb-3 ml-2" v-show="keyFeatureEnhanced === 2">
                Make your office more visible online with local SEO; customers looking for agents in your area will find you quickly and simply, helping to drive high-quality traffic and leads to your website.
              </p>
            </div>
            <div class="border-l-2" :class="{'border-guild-plan-orange': keyFeatureEnhanced === 3}">
              <h5 class="mb-1 ml-2">
                Email marketing solution
                <button @click="keyFeatureEnhanced = 3" v-show="keyFeatureEnhanced !== 3" class="font-normal ml-2"><i class="fa fa-angle-down"></i>
                </button>
              </h5>
               <p class="text-xs leading-tight mb-3 ml-2" v-show="keyFeatureEnhanced === 3">
                We can take care of your nurture journey for you with our marketing solution with emails and newsletters, some of which we can automate. You will have access to a content library of campaigns, customer journey marketing triggered at key milestones identified via your CRM, and access to an auto-property matcher, so you can match buyers with new properties in your CRM based on their criteria.
              </p>
            </div>
            <div class="border-l-2" :class="{'border-guild-plan-orange': keyFeatureEnhanced === 4}">
              <h5 class="mb-1 ml-2">
                Quarterly mystery shop
                <button @click="keyFeatureEnhanced = 4" v-show="keyFeatureEnhanced !== 4" class="font-normal ml-2"><i class="fa fa-angle-down"></i>
                </button>
              </h5>
               <p class="text-xs leading-tight mb-3 ml-2" v-show="keyFeatureEnhanced === 4">
                In a business focused on interactions with people, it is vital to understand how your agency measures up. With our quarterly mystery shop and accompanying report, you can benchmark your business, build up and evolve your team’s abilities and understand the sales process and customer experience delivered to your customers.
              </p>
            </div>
            <button class="leading-tight mb-4 px-4 py-2 bg-guild-plan-orange text-white mt-4 uppercase rounded text-xs" v-show="selectedOffice.role !== 'Premium'" @click="openLink(selectedOffice.role === 'Enhanced' ? 'Active Plan' : 'Upgrade To This Plan')">
              {{selectedOffice.role === 'Enhanced' ? 'Active Plan' : 'Upgrade To This Plan'}}
            </button>
          </div>
        </div>
      </div>
      <div class="w-full mt-12">
      <h3 class="mb-3 text-center uppercase">
        THIS PLAN ALSO INCLUDES:
      </h3>
      <p class="text-xs leading-tight mt-2 text-center">
        Products you have access to under your Plan will be highlighted by a tick.
      </p>
      </div>
    </div>
      <div class="flex flex-wrap ml-6 mt-3 pt-3">
      <div class="w-full md:w-1/4 flex flex">
        <div class="md:w-1/5" style="width: 16%;">
          <i class="fas fa-check-square fa-lg text-guild-plan-orange"></i>
        </div>
        <div class="md:w-4/5">
          <span class="text-sm font-bold">
            The Guild of Property Professionals Membership
          </span>
          <p class="text-xs leading-tight mt-2">
            Exclusive Guild Membership gives your business a differentiator, a unique selling point that ensures you stand out.
          </p>
        </div>
        </div>
        <div class="w-full md:w-1/4 flex flex">
        <div class="md:w-1/5" style="width: 16%;">
          <i class="fas fa-check-square fa-lg text-guild-plan-orange"></i>
        </div>
        <div class="md:w-4/5">
          <span class="text-sm font-bold">
            Annual compliance training and audit
          </span>
          <p class="text-xs leading-tight mt-2">
            Get compliance peace of mind with an annual check-in on key business requirements such as ICO registration, Redress Scheme membership and AML requirements.
          </p>
        </div>
        </div>
        <div class="w-full md:w-1/4 flex flex">
        <div class="md:w-1/5" style="width: 16%;">
          <i class="fas fa-check-square fa-lg text-guild-plan-orange"></i>
        </div>
        <div class="md:w-4/5">
          <span class="text-sm font-bold">
            Associate Training Scheme with CPD points
          </span>
          <p class="text-xs leading-tight mt-2">
            Access our Knowledge Hub and complete our Associate Scheme for Sales and Lettings. On successful completion, Members receive an ID card and a certificate.
          </p>
        </div>
      </div>
        <div class="w-full md:w-1/4 flex flex">
        <div class="md:w-1/5" style="width: 16%;">
          <i class="fas fa-check-square fa-lg text-guild-plan-orange"></i>
        </div>
        <div class="md:w-4/5">
          <span class="text-sm font-bold">
            Compliance tools protection plan and Primary Authority Partnership
          </span>
          <p class="text-xs leading-tight mt-2">
            Be part of our Primary Authority Partnership with Cambridgeshire Trading Standards, Ask Paul (our Group Compliance Officer) anything and access our toolbox of documents, updates and guides.
          </p>
        </div>
        </div>
      </div>
      <div class="flex flex-wrap ml-6 mt-3 pt-3">
      <div class="w-full md:w-1/4 flex flex">
        <div class="md:w-1/5" style="width: 16%;">
          <i class="fas fa-check-square fa-lg text-guild-plan-orange"></i>
        </div>
        <div class="md:w-4/5">
          <span class="text-sm font-bold">
            Professional Indemnity (PI) Insurance
          </span>
          <p class="text-xs leading-tight mt-2">
            All Members are eligible to participate in The Guild’s Group Policy, pending confirmation of Ombudsman Membership and adherence to our own Code of Conduct.
          </p>
        </div>
      </div>
      <div class="w-full md:w-1/4 flex flex">
        <div class="md:w-1/5" style="width: 16%;">
          <i class="fas fa-check-square fa-lg text-guild-plan-orange"></i>
        </div>
        <div class="md:w-4/5">
          <span class="text-sm font-bold">
            Property market intelligence system
          </span>
          <p class="text-xs leading-tight mt-2">
            Understand your competitors (fall-throughs, price reductions, etc.) and benchmark your own business with our Market Insight tool.
          </p>
        </div>
      </div>
      <div class="w-full md:w-1/4 flex flex">
        <div class="md:w-1/5" style="width: 16%;">
          <i class="fas fa-check-square fa-lg text-guild-plan-orange"></i>
        </div>
        <div class="md:w-4/5">
          <span class="text-sm font-bold">
            Social media and digital marketing training
          </span>
          <p class="text-xs leading-tight mt-2">
            Detailed training resources on how to make the most of your social media channels as well as access our toolkit for tips, tricks and tactics.
          </p>
        </div>
      </div>
      <div class="w-full md:w-1/4 flex flex">
        <div class="md:w-1/5" style="width: 16%;">
          <i class="fas fa-check-square fa-lg text-guild-plan-orange"></i>
        </div>
        <div class="md:w-4/5">
          <span class="text-sm font-bold">
            Bespoke branded magazine in print and digital
          </span>
          <p class="text-xs leading-tight mt-2">
            We prepare a magazine branded to your business with eight property pages surrounded by lifestyle editorial content. You have 50 printed copies, as well as a digital version.
          </p>
        </div>
      </div>
    </div>
    <div class="flex flex-wrap ml-6 mt-3 pt-3">
      <div class="w-full md:w-1/4 flex flex">
        <div class="md:w-1/5" style="width: 16%;">
          <i class="fas fa-check-square fa-lg text-guild-plan-orange"></i>
        </div>
        <div class="md:w-4/5">
          <span class="text-sm font-bold">
            Digital interactive magazine <span class="italic font-normal">with email distribution</span>
          </span>
          <p class="text-xs leading-tight mt-2">
            Our automated, fortnightly digital magazine created using your property listings is then distributed via email to your database with zero effort from your team.
          </p>
        </div>
      </div>
      <div class="w-full md:w-1/4 flex flex">
        <div class="md:w-1/5" style="width: 16%;">
          <i class="fas fa-check-square fa-lg text-guild-plan-orange"></i>
        </div>
        <div class="md:w-4/5">
          <span class="text-sm font-bold">
            Quarterly regional market reports <span class="italic font-normal">with email distribution</span>
          </span>
          <p class="text-xs leading-tight mt-2">
            Access 16 regional reports which cover the UK each quarter. Available as digital page-turners, video scripts, social media assets and a white label press release, we offer a complete market update campaign. We will also distribute these via email to your database for you.
          </p>
        </div>
      </div>
      <div class="w-full md:w-1/4 flex flex">
        <div class="md:w-1/5" style="width: 16%;">
          <i class="fas fa-check-square fa-lg text-guild-plan-orange"></i>
        </div>
        <div class="md:w-4/5">
          <span class="text-sm font-bold">
            The Guild print solution with design library
          </span>
          <p class="text-xs leading-tight mt-2">
            Branded seasonal and topical print at the click of a button (Digital Hub), plus a marketing service that can target streets with average sale prices (Fee Street), and a tool that can help you market to properties either side of newly listed, sold or let properties (Auto Direct Mail).
          </p>
        </div>
      </div>
      <div class="w-full md:w-1/4 flex flex">
        <div class="md:w-1/5" style="width: 16%;">
          <i class="fas fa-check-square fa-lg text-guild-plan-orange"></i>
        </div>
        <div class="md:w-4/5">
          <span class="text-sm font-bold">
            Video tools <span class="italic font-normal">property presentation and professional branding</span>
          </span>
          <p class="text-xs leading-tight mt-2">
            From properties to people, video is a marketing essential. Animate your properties with our automated videoettes and present a polished agency with professionally branded videos.
          </p>
        </div>
      </div>
    </div>
    <div class="flex flex-wrap ml-6 mt-3 pt-3">
      <div class="w-full md:w-1/4 flex flex">
        <div class="md:w-1/5" style="width: 16%;">
          <i class="fas fa-check-square fa-lg text-guild-plan-orange"></i>
        </div>
        <div class="md:w-4/5">
          <span class="text-sm font-bold">
            Website live chat service
          </span>
          <p class="text-xs leading-tight mt-2">
            With your website being the first port of call for most homeowners and house hunters, website live chat helps convert your web traffic to leads.
          </p>
        </div>
      </div>
      <div class="w-full md:w-1/4 flex flex">
        <div class="md:w-1/5" style="width: 16%;">
          <i class="fas fa-check-square fa-lg text-guild-plan-orange"></i>
        </div>
        <div class="md:w-4/5">
          <span class="text-sm font-bold">
            Lead generation tools <span class="italic font-normal">with Dashboard for Lead Management</span>
          </span>
          <p class="text-xs leading-tight mt-2">
            In addition to the trio of tools in the Standard plan, the Enhanced plan includes a lead management dashboard for your instant online valuations, 24/7 portal enquiry responder and a valuation appointment booking service. This way, all leads can be managed from one central space, driving efficiency into gaining new business.
          </p>
        </div>
      </div>
      <div class="w-full md:w-1/4 flex flex">
        <div class="md:w-1/5" style="width: 16%;">
          <i class="fas fa-check-square fa-lg text-guild-plan-orange"></i>
        </div>
        <div class="md:w-4/5">
          <span class="text-sm font-bold">
            Chain repair service
          </span>
          <p class="text-xs leading-tight mt-2">
            From speedy sales to fall-throughs, our ibuyer is a quick, efficient and trusted buying solution.
          </p>
        </div>
      </div>
    </div>
    <div class="w-full mt-12 bg-grey-lighter">
      <h3 class="mb-3 text-center uppercase mt-6">
        ADDITIONAL PACK BENEFITS
      </h3>
      <p class="text-xs leading-tight mt-2 text-center mb-6">
      </p>
      <div class="flex flex-wrap ml-6 mt-3 pt-3 mb-12">
        <div class="w-full md:w-1/4 text-center">
          <div class="flex w-full justify-center">
           <icon class="w-20 h-20" name="enhanced_discount_pound" :center="false" />
          </div>
          <p class="text-xs leading-tight mt-2">
            Access to preferential
          </p>
          <p class="text-xs leading-tight mt-2">
            services in The Guild Partner Scheme
          </p>
        </div>
        <div class="w-full md:w-1/4 text-center">
          <div class="flex w-full justify-center">
           <icon class="w-20 h-20" name="enhanced_discount_20" :center="false" />
          </div>
          <p class="text-xs leading-tight mt-2">
            Discounted
          </p>
          <p class="text-xs leading-tight mt-2">
            Guild Member website
          </p>
        </div>
        <div class="w-full md:w-1/4 text-center">
          <div class="flex w-full justify-center">
           <icon class="w-20 h-20" name="enhanced_discount" :center="false" />
          </div>
          <p class="text-xs leading-tight mt-2">
            Discount on
          </p>
          <p class="text-xs leading-tight mt-2">
            digital marketing packages
          </p>
        </div>
        <div class="w-full md:w-1/4 text-center">
          <div class="flex w-full justify-center">
           <icon class="w-20 h-20" name="enhanced_discount" :center="false" />
          </div>
          <p class="text-xs leading-tight mt-2">
            Discounted
          </p>
          <p class="text-xs leading-tight mt-2">
            mystery shopping services
          </p>
        </div>
      </div>
    </div>
  </panel>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      keyFeatureEnhanced: 1
    }
  },
  computed: {
    ...mapState(['selectedOffice'])
  },
  methods: {
    openLink (type) {
      if (type === 'Upgrade To This Plan') {
        window.open('https://www.guildproperty.co.uk/plan', '_blank')
      }
    }
  }
}
</script>
